export class Service {
  id?: number;
  name?: string;
  nomarab?: string; 
    nomanglais?: string;           // <-- Arabic name
  description?: string;
  agencyName?: string;
  prix?: string;
  imageUrl?: string;
  status?: string;
  categorie?: string;
  categoryList?: string[];      // French/English
  categoryListarab?: string[];  // <-- Arabic categories
    categoryListanglais?: string[]; 
  promoTitle?: string;
  promoImg?: string;
  videoUrl?: string;
  hasAtelier?: boolean;
}